<!--
 * @Author: Merlin
 * @Date: 2023-12-18 19:26:04
 * @LastEditors: Merlin
 * @LastEditTime: 2025-08-29 15:28:25
 * @Description: 
-->
<template></template>
<script lang="ts" setup>
import { useBalance1Socket } from '~/socket/balance1';
import { useAuthSocket } from '~/socket/auth';
import { useRegularSocket } from '~/socket/regular';
import { useProfileSocket } from '~/socket/profile';
import { useGameSocket } from '~/socket/game'; 
import { useLoging } from '~/socket/logoff'; 
import { useJackPotSocket } from '~/socket/jackpot';
import { useHome } from '@/socket/home/index';
// --- ↑ socket ---------------------------------------------
import { useGameIdListStore } from '~/stores/cansino/gameIdList';
import { useUserStore } from '~/stores/user';
import { useRatesStore } from '~/stores/cansino/rates';
import useSettingsStore from '@/stores/settings/index';
import { useJoinStateStore } from '~/stores/cansino/joinState';
import useGlobalStore from '@/stores/global';
import { useAuthStore, destroyToken } from '~/stores/auth';
import {useAutoOptionStore} from '@/stores/cansino/autoOption';
// --- ↑ store ---------------------------------------------
import {getGameName, getGameInfo, getGameApi, getGameLastRoundKey} from '@/common/js/gameAbout';
import { Dialog } from 'quasar';
import { useNoticeDialog } from '~/composables/useNoticeDialog';
import imageBase64 from '@/components/imageBase64.js';

const showNoticeDialog = useNoticeDialog();
import OrangeDog from "@/assets/imgs/npc.webp"
import OrangeBg from "@/assets/imgs/orange-bg.webp"
import OrangeOops from "@/assets/imgs/orange-oops.webp"

const globalStore = useGlobalStore();
const userStore = useUserStore();
const rates = useRatesStore();
const oSettingsStore = useSettingsStore();
const oJoinStateStore = useJoinStateStore();
const gameIdListStore = useGameIdListStore();
// -------- ↑ 各种 store --------------------
// -------- ↓ 一些 socket --------------------
const { ON_UPDATE_CURRENCY } = useHome();
const { EMIT_GAME_JOIN } = useGameSocket();
const { ON_BALANCES } = useBalance1Socket();
const { ON_UPDATE_RATES } = useRegularSocket();
const { EMIT_PROFILE_GETCURRENCIES } = useProfileSocket();
const { EMIT_JACKPOT_GETSUM } = useJackPotSocket()
const { ON_DISQUALIFIED, ON_LOGOUT } = useLoging();
const { ON_STATECHANGE } = useAuthSocket();

// ↓ 当前页自建的一些变量等 
let fnDismissAlertInfo = ()=>null;
let oDialogForNetwork = null;
let iNetworkTipsInterval = null;
let fnDismissLock = () => null;
const route = useRoute();
const lockMsg = ref('');
const ZHAJINHUA_INDOOR = '/casino/zhajinhuaGame/indoor';

// 👇注册监币种切换
// 主要应对当用户打开多个页面时，在其它页切换了币种，在此会收到消息 
ON_UPDATE_CURRENCY((data) => {
    // 入参示例： {currency: 'cny'} 
    if (1 && import.meta.dev){
        console.log('币种切换了 =>', JSON.stringify(data)); 
    }
    const sCurrency = (data?.currency || '').toUpperCase();
    if (!sCurrency) return;
    const $tFn = useNuxtApp().$i18n.t;
    const iRequestAt = oSettingsStore.pickedCurrencyTs || 0;
    const iGapMs = Date.now() - iRequestAt;
    console.log('pickedCurrencyTs Gap (ms) =', iGapMs); 
    // ↓ 发起“币种设定” 与“设定完毕” 间隔小于 1秒 
    // ↓ 那么判定为【当前页】自己发起的币种切换，不做任何处理，在其它位置处理了这类情况 
    if (iGapMs >= 0 && iGapMs < 1_000) return;
    // ↓ 其它页发起的币种切换，当前页应采取一些措施 
    // ↓ 最后弹出提示
    fnDismissAlertInfo?.();
    fnDismissAlertInfo = showNegativeNotify({
        message: $tFn('commonInfo.currencyChangedTo') + ` ${sCurrency}`, 
        caption: $tFn('commonInfo.currencyChangedDesc'), 
        icon: 'announcement',
        timeout: 0, // 提示弹出后不自动消退
        position: 'top',
        type: 'info',
    });
    userStore.currentCurrency = data.currency;
    oSettingsStore.pickedCurrency = data.currency;
});


// 👇注册监听器，监听余额变化，并实时更新余额
ON_BALANCES((data) => {
    const aKeys = Object.keys(data || {});
    if (!aKeys.length) return;
    // 入参通常表示某个币种最新的余额情况，格式如下：
    // {usdt: {balance: 6276.72001438, cashback: 0, rakeBackValue: 0, rakeBackValueUSD: 0}}
    if (0 && import.meta.dev){
        console.log('余额更新了 =>', JSON.stringify(data)); 
    }
    if (
        aKeys.length === 1
        && aKeys[0] !== oSettingsStore.pickedCurrency
    ){
        console.warn('注意：非当前币种的余额有变动！疑似之前有币种切换失败(waves 结算导致的除外)');
        if (0 && import.meta.dev) debugger; 
    }
    userStore.updataOneBalance(data);
});

// 账号被冻结提示
const lockNotice = () => {
    // 提示账号被冻结
    fnDismissLock?.();
    fnDismissLock = showNegativeNotify({
        position: 'top',
        type: 'warning',
        i18n: 'commonInfo.locked',
    })
    lockMsg.value = '';
}

ON_STATECHANGE(data => {
    if (data.status === 'locked') {
        // 炸金花游戏页面 切在游戏中的话 等待游戏结束在提示账号被冻结
        if (route.path.includes(ZHAJINHUA_INDOOR) && oJoinStateStore.gameRunning) { 
            lockMsg.value = '账号已冻结，请联系客服';
            return ;
        }
        // 提示账号被冻结
        lockNotice();
    } else {
        lockMsg.value = '';
    }
});

// 容错手段。其实数据已经在服务端就绪推到浏览器了。 
const hasRatesRead = Object.values(rates.comparisonCurrencyList).every(cur => {
    return cur > 0;
});
if (!hasRatesRead){
    // 👇拿取初始匯率
    console.log('🔄 [Global] 服务端汇率未就绪，正在补充加载...'); 
    EMIT_PROFILE_GETCURRENCIES((res) => {
        saveRateInfor(res);
        if (import.meta.dev) {
            console.log('✅ [Global] 汇率数据补充加载完成');
        }
    });
}else if(1 && import.meta.dev){
    console.log('✅ [Global] 汇率数据早已就绪'); 
}

// 👇注册匯率更新听器
ON_UPDATE_RATES(saveRateInfor);


// ↓ 监听用户切换币种, 切换界面语言
// ↓ 然后将触发游戏的重载 
watch(
    [
        ()=>oSettingsStore.pickedCurrency,
        ()=>oSettingsStore.UILang,
    ],
    fnGameReloader,
);

// ↓ 监听网络链接，在链接中断时弹出提示 
watch(
    () => globalStore.wsConnection,
    (bStatusNew, bStatusOld)=>{
        console.log(bStatusNew,'bStatusNew00000')
        const $tFn = useNuxtApp().$i18n.t;
        // ↓ 如果是因为"新窗口打开游戏"而主动断开的，不显示网络断开对话框
        if (oJoinStateStore.gameStartedInNewTab) return;
        if (bStatusNew){ // 断线后重新链接了 
            clearInterval(iNetworkTipsInterval);
            if (oDialogForNetwork){
                oDialogForNetwork.hide(); 
            }
            // 断线重连后清空余额队列，防止队列残留导致 balanceDelay 无法更新
            if (userStore.balanceQueue.length) {
                console.log('[ws] 重连后清空余额队列，残留项数:', userStore.balanceQueue.length);
                userStore.balanceQueue = [];
            }
            // 将各币种的 balanceDelay 同步为最新的 balance，修正断线期间的显示滞后
            for (const oCur of Object.values(userStore.currencies)) {
                if (oCur && typeof oCur.balance === 'number') {
                    oCur.balanceDelay = oCur.balance;
                }
            }
            return showNegativeNotify({
                i18n: 'commonInfo.wsRestored',
                type: 'positive',
                position: 'top',
                timeout: 2.5 * 1_000, 
            });
        }
        let percentage = 0;
        // 🌐 显示连接中提示
        oDialogForNetwork = showNoticeDialog({
            networkNotice: true,
            mainTitle: percentage + '%',
            mainText: $tFn('commonInfo.networkInstability'),
            displaySubText: $tFn('commonInfo.attemptingReconnect'),
            persistent: true,
        });
        
        const durationMS = 1_000 * 4.5; 
        const oneStepMS = 380;
        iNetworkTipsInterval = setInterval(async () => {
            const addition = Math.round(oneStepMS / durationMS * 100);
            percentage = Math.min(100, percentage + addition); 
            
            // 🔄 更新连接进度显示
            if (oDialogForNetwork && typeof oDialogForNetwork.update === 'function') {
                oDialogForNetwork.update({
                    mainTitle: percentage + '%',
                });
            }
            
            if (percentage < 100) return; 
            clearInterval(iNetworkTipsInterval);
            
            // 🚫 连接失败，关闭当前对话框并显示失败提示
            if (oDialogForNetwork && typeof oDialogForNetwork.hide === 'function') {
                oDialogForNetwork.hide();
            }
            
            // 等待一小段时间让关闭动画完成
            await new Promise(resolve => setTimeout(resolve, 200));
            
            // 💔 显示连接失败对话框
            oDialogForNetwork = showNoticeDialog({
                title: $tFn('commonInfo.info'),
                mainText: $tFn('commonInfo.badNetwork'), 
                buttonText: $tFn('commonInfo.refresh'),
                dogImage: imageBase64.orangeDog,
                bgImage: imageBase64.orangeBg,
                oopsImage: imageBase64.yellowOops,
                confirmColor: 'red',
                themeStyle:'border-radius: 12px;border: 1px solid var(--orange, #FF7F00);background: #111D2A;',
                persistent: true
            });
            
            // 点击刷新按钮后重载页面
            oDialogForNetwork.then((confirmed) => {
                if (confirmed) {
                    window.location.reload();
                }
            }).catch(() => {
                // 用户取消或关闭对话框
            });
        }, oneStepMS);
    },
);

// 炸金花游戏中账号冻结，等待游戏结束提示账号被冻结
watch(() => [route.path, oJoinStateStore.gameRunning, lockMsg.value], (val: [string, boolean, string]) => {
    const [path = '', gameRunning, hasMsg] = val || [];
    if(path.includes(ZHAJINHUA_INDOOR) && hasMsg && !gameRunning) {
        lockNotice();
    }
})

// ↓ 拿取遊戲ID及名字對照表 
// ↓ 以下接口在服务器侧已经查过一次了，并保存到 store 中推到了前端（用于页面尽早取得此数据）
// ↓ 在此使用“当前用户身份” 二次查询，用于取得此用户的高频游戏 (oftenPlayed == true)
if (import.meta.client){
    gameIdListStore.initData(900);
}

// 👇 监听 “丧失游戏资格” 事件
// 因为已经在新窗口开启同一游戏，当前窗口禁止操作 
ON_DISQUALIFIED(intCode => {
    console.log("intCode1：", intCode); 
    if (intCode != 8888) return;
    // ↓ 服务器只会向"在游戏中"的用户发送 log_off code 8888
    // ↓ 收到此事件本身就说明用户之前在游戏中，无需再检查 gameOfRoute
    // ↓ 做记录： 已经在新窗口打开游戏，当前窗口失效 
    // ↓ 注意：必须先设置标记，再断开 socket，否则 watch 触发时标记还是 false
    oJoinStateStore.gameStartedInNewTab = true;
    // ↓ 立即关闭 websocket 不再继续收发信息  
    socket.disconnect();
    // ↓ 最后弹出提示
    // ↓ 提示用户登录状态失效，点击确定后返回首页 
    const $tFn = useNuxtApp().$i18n.t;
    const dialog = showNoticeDialog({
        title: $tFn('Note'),
        mainText: $tFn('commonInfo.newTabGaming'), 
        buttonText: $tFn('commonInfo.goHomePage'),
        dogImage: OrangeDog,
        bgImage: OrangeBg,
        oopsImage: OrangeOops,
        confirmColor: 'red',
        themeStyle:'border-radius: 12px;border: 1px solid var(--orange, #FF7F00);background: #111D2A;',
        persistent: true
    });

    // 点击按钮后跳转首页
    dialog.then((confirmed) => {
        if (confirmed) {
            const sPath = getLocalPath('/');
            // ↓ 说明，push() 此操作安全性不足 
            // ↓ 因为修改路由时游戏时会触发请求报告用户离场，导致最后一次(最新的一次)访问游戏的页面失效 
            window.location.href = sPath; // 安全性更高 
            nextTick(() => {
                useRouter().push(sPath);
            })
        }
    }).catch(() => {
        // 用户取消或关闭对话框
    });
});

// ↓ 监听路由变化：如果 gameStartedInNewTab 为 true，强制刷新页面
// ↓ 因为 socket 已断开，SPA 路由切换会导致网络功能不可用
watch(
    () => useRoute().fullPath,
    (newPath) => {
        if (oJoinStateStore.gameStartedInNewTab) {
            window.location.href = newPath;
        }
    }
);

// ↓ 监听 “登录失效” 事件
// ↓ 可能被踢下线 
// ↓ 可能用户主动执行退出
// ↓ 可能在其它浏览器删除了当前 session 
ON_LOGOUT(intCode => {
    console.log('intCode', intCode); 
    // 收到此号码，表示登录失效了  
    if (intCode != 8889) return;
    // ↓ 无提示，直接刷新浏览器，使其失去登录状态（旧版）
    // destroyToken({ showTips: false });
    socket.disconnect();
    useAuthStore().cleanToken();
    userStore.currencies = {}; // 使表现为未登录。伴生效果，同时会清空余额终止自动下注 
    oJoinStateStore.gameRunning = false; // 取消正在游戏中的状态标记 
    const $tFn = useNuxtApp().$i18n.t;

    const dialog = showNoticeDialog({
        title: $tFn('commonInfo.userOffLineTitle'),
        mainText: $tFn('commonInfo.userOffLineDesc'), 
        buttonText: $tFn('commonInfo.confirm'),
        dogImage: OrangeDog,
        bgImage: OrangeBg,
        oopsImage: OrangeOops,
        confirmColor: 'red',
        themeStyle:'border-radius: 12px;border: 1px solid var(--orange, #FF7F00);background: #111D2A;',
        persistent: true
    });
    // 点击按钮后跳转首页
    dialog.then((confirmed) => {
        if (confirmed) {
            const sPath = getLocalPath('/');
            // ↓ 说明，push() 此操作安全性不足 
            // ↓ 因为修改路由时游戏时会触发请求报告用户离场，导致最后一次(最新的一次)访问游戏的页面失效 
            // useRouter().push(sPath); 
            window.location.href = sPath; // 安全性更高 
        }
    }).catch(() => {
        // 用户取消或关闭对话框
    });
});

// 获取各游戏jackpot数据
EMIT_JACKPOT_GETSUM({}, (res) => {
    console.log(res, 'EMIT_JACKPOT_GETSUM');
    globalStore.jackpotSum = res;
});


// ↓ 可以延迟查询的信息 
setTimeout(async ()=>{
    // ↓ 查询用户未读消息数量 
    userStore.updateUnreadCount();
}, 2_000);

// ==== ↓ 一些被动的方法 ===========

// ↓保存匯率信息 
// ↓是动查询和被动地收到后端推送的信息后都传递到这个方法进行处理，保存 
function saveRateInfor(res) {
    if (!res) return;
    const result = {};
    Object.entries(res).forEach(([key, value]) => {
        if (key.startsWith('usdt')) {
            result[key] = value;
        }
    });
    // console.log('匯率信息=>', deepCopy(res));
    if (!result['usdtusdt'] && import.meta.dev){
        console.error('注意：没有汇率'); // debugger;
    }
    rates.setState({
        comparisonCurrencyList: res,
        usdtComaparisonCurrencyList: result as any,
    });
};

// ↓ 游戏重新加载 
// ↓ 主要在切换币种，切换界面语言后调用（因为这时届时会触发页面刷新，涉及以游戏重载） 
async function fnGameReloader(){
    if (!getGameName()){
        return; // 不在游戏页，自然不需要重载游戏 
    }
    const oAutoOption = useAutoOptionStore();
    oAutoOption.isAutoBetting = false; // 出于安全，把自动下注关闭 
    oJoinStateStore.gameRunning = false; // 取消正在游戏中的状态标记 
    // ↓ 某些游戏有一个属性在保存着上局未完成的游戏，在此查出这个键名 
    // ↓ 查到了键名，说明此游戏在刷新后和切换币种、切换界面语言后要加载“进行中的局” 
    const sKey2Clearn = getGameLastRoundKey();
    console.log("清空游戏历史，清空键：", sKey2Clearn || '无');
    if (sKey2Clearn) {
        oJoinStateStore[sKey2Clearn] = null; // 清空它，查询后赋新值
    }
    // ↑ 实测得出：务必要将清空动作要放在顶部“先”执行，然后再在下方后执行重载（否则重载后尚未清空，误用了旧数据） 
    // ↓ 触发游戏重新加载，因为不同币种下有不同的游戏记录
    globalStore.markForReload++;
    globalStore.redpacketReload++;
    if (!sKey2Clearn) return;
    // ↓ 一定要等待，借此确保先执行 beforeUnmounted() 的内部事件执行完毕
    await nextTick();
    await Sleep(100);
    const sApi = getGameApi();
    // TODO 需要注意，在“抢红包” 等新游戏上线后以下接口未必有适用于这些新游戏 
    // 当时，如果 sKey2Clearn 取值为空，也不会走到这里 
    EMIT_GAME_JOIN(sApi, {}, (data) => {
        if (!data || data.error) {
            showNegativeNotify(data?.error); 
            return;
        }
        const newData = deepCopy(data[sKey2Clearn]); 
        if (!newData) return; 
        oJoinStateStore[sKey2Clearn] = newData;
    });
}

</script>

<style lang="scss">
// 这里是“全局” 样式，注意 
.q-dialog__inner .network-dialog-r4v9my{
    width: 90vw;
    max-width: 350px;
    &.connecting{
        text-align: center; 
        .q-spinner{
            margin: 20px auto 10px; 
        }
    }
    &.connection-failed{
        opacity: 1; // 占位 
    }
    &.connection-restored{
        opacity: 1; // 占位 
    }
}

</style>
